import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children, permission }) => {
  const { isAuthenticated, loading, user, hasPermission } = useAuth();

  // ✅ No mostrar nada mientras carga (App.js ya maneja el loading)
  if (loading) {
    return null;
  }

  // ✅ Si no está autenticado, redirigir a login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // ✅ Si no está aprobado, redirigir a pending
  if (user && !user.is_approved && user.role !== 'super_admin') {
    return <Navigate to="/pending-approval" replace />;
  }

  // ✅ Verificar permisos si se especifica
  if (permission && !hasPermission(permission)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;
